import React, { useState, useEffect } from 'react';
import registryDesktop from '../Images/desktophighqualityreg.mp4';
import registryMobile from '../Images/registrymobilepage.mp4';
import '../styles/RegistryPage.css';

function RegistryPage() {
  const [isMobile, setIsMobile] = useState(false);
  const [containerHeight, setContainerHeight] = useState('100vh');

  // Detect mobile vs desktop
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  // Update container height on mobile
  useEffect(() => {
    if (isMobile) {
      setContainerHeight('120vh'); // taller mobile container
      document.body.style.overflow = 'hidden';
    } else {
      setContainerHeight('100vh');
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobile]);

  return (
    <div className="video-container" style={{ height: containerHeight }}>
      <video
        src={isMobile ? registryMobile : registryDesktop}
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: '100vw',
          height: '100%',
          objectFit: isMobile ? 'fill' : 'contain',
          display: 'block',
        }}
      />

      <button
        className="video-button button-one"
        onClick={() =>
          window.open(
            'https://www.crateandbarrel.com/gift-registry/emily-gillespie-and-corey-hutson/r7364104'
          )
        }
      />
      <button
        className="video-button button-two"
        onClick={() =>
          window.open(
            'https://www.amazon.com/wedding/registry/1HR7V6DAPH7A7?ref=wr_search_page_result_1'
          )
        }
      />
      <button
        className="video-button button-three"
        onClick={() =>
          window.open('https://www.honeyfund.com/site/hutson-gillespie-06-06-2026')
        }
      />
    </div>
  );
}

export default RegistryPage;
